var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAthleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6993 33.0321C47.369 33.0321 48.735 31.6661 48.735 29.9964C48.735 28.3268 47.369 26.9607 45.6993 26.9607C44.0297 26.9607 42.6636 28.3268 42.6636 29.9964C42.6636 31.6661 44.0297 33.0321 45.6993 33.0321ZM40.235 54.1304L41.7529 47.4518L44.9404 50.4875V59.5946H47.9761V48.2107L44.7886 45.175L45.6993 40.6214C47.6725 42.8982 50.7083 44.4161 54.0475 44.4161V41.3804C51.1636 41.3804 48.735 39.8625 47.5208 37.7375L46.0029 35.3089C45.3958 34.3982 44.485 33.7911 43.4225 33.7911C42.9672 33.7911 42.6636 33.9429 42.2083 33.9429L34.3154 37.2821V44.4161H37.3511V39.2554L40.0833 38.1929L37.6547 50.4875L30.2172 48.9696L29.61 52.0054L40.235 54.1304Z",
    fill: "#592EE5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.69664,
    y: 1.1875,
    width: 83.4821,
    height: 83.4821,
    rx: 41.7411,
    stroke: "#091F82",
    strokeWidth: 1.51786
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthleteIcon);
export default __webpack_public_path__ + "static/media/athlete_icon.8c29681cb850510fc9a4b0f85f2d6e85.svg";
export { ForwardRef as ReactComponent };